import { render } from "./TelemetryNamibie.vue?vue&type=template&id=01e7fd20"
import script from "./TelemetryNamibie.vue?vue&type=script&lang=js"
export * from "./TelemetryNamibie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__